import React, { lazy } from 'react';
import { Check } from 'lucide-react';
interface OrderBumpProps {
  isChecked: boolean;
  onToggle: () => void;
}
export function OrderBump({
  isChecked,
  onToggle
}: OrderBumpProps) {
  return <div className={`relative mt-8 rounded-xl border-2 transition-all duration-300 cursor-pointer text-left overflow-hidden group ${isChecked ? 'border-[#00FF66] bg-[#0a140f] shadow-[0_0_30px_rgba(0,255,102,0.15)]' : 'border-[#333] bg-[#0a0a0a] hover:border-[#00FF66]/50 hover:shadow-[0_0_20px_rgba(0,255,102,0.05)]'}`} onClick={onToggle} data-id="element-605">
      {/* Badge */}
      <div className="absolute top-3 right-3 bg-[#00FF66] text-black text-[10px] font-bold px-3 py-1 rounded-full shadow-[0_0_10px_rgba(0,255,102,0.5)] z-10 animate-pulse" data-id="element-606">
        85% DCTO
      </div>

      {/* Title bar with pulse */}
      <div className="bg-gradient-to-r from-[#b8942e] via-[#d4af37] to-[#e8c84a] px-6 py-3 flex items-center gap-2" data-id="element-607">
        <span className="relative flex h-2.5 w-2.5" data-id="element-608">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#d4af37] opacity-75" data-id="element-609"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#f5f0e8]" data-id="element-610"></span>
        </span>
        <span className="text-black font-bold text-sm tracking-wide uppercase" data-id="element-611">
          Altamente recomendado
        </span>
      </div>

      <div className="p-6" data-id="element-612">
        {/* Header with Checkbox */}
        <div className="flex items-start gap-4 mb-6 bg-[#111] p-4 rounded-lg border border-[#222] group-hover:border-[#00FF66]/30 transition-colors" data-id="element-613">
          <div className={`mt-1 w-8 h-8 rounded flex items-center justify-center flex-shrink-0 transition-all duration-300 border-2 shadow-inner ${isChecked ? 'bg-[#00FF66] border-[#00FF66] shadow-[0_0_15px_rgba(0,255,102,0.6)] scale-110' : 'bg-[#050505] border-[#555] group-hover:border-[#00FF66]'}`} data-id="element-614">
            {isChecked && <Check className="w-6 h-6 text-black" strokeWidth={4} data-id="element-615" />}
          </div>
          <h4 className={`font-bold text-lg leading-tight transition-colors ${isChecked ? 'text-[#00FF66]' : 'text-[#f5f0e8]'}`} data-id="element-616">
            ¡Sí! Quiero añadir "Psicología del Dinero" por solo $40.000 COP
          </h4>
        </div>

        <div className="flex flex-col md:flex-row gap-6" data-id="element-617">
          {/* Image */}
          <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-618">
            <img src="https://cdn.magicpatterns.com/uploads/9K8WpxH2mckojnRJjGFCLo/Imagen_Miniatura-_Psicologia_dinero.png" alt="Psicología del Dinero para Traders" className="w-full h-auto rounded-lg shadow-lg border border-[#222]" loading="lazy" decoding="async" data-id="element-619" />
          </div>

          {/* Content */}
          <div className="w-full md:w-2/3 space-y-4" data-id="element-620">
            <p className="text-[#8a8578] text-sm leading-relaxed" data-id="element-621">
              ¿Has notado que cuando ganas te vuelves imprudente y cuando
              pierdes te urge "recuperar"? Eso es tu Termostato Financiero
              saboteando tu cuenta para devolverte a tu zona de confort. No te
              falta estrategia, te falta identidad frente al dinero.
            </p>
            <p className="text-[#8a8578] text-sm leading-relaxed" data-id="element-622">
              Con este Manual Maestro de 60 páginas, hackearás tu relación con
              el dinero bajo presión utilizando el sistema SER-HACER-TENER.
            </p>

            <div className="space-y-2 pt-2" data-id="element-623">
              <p className="text-[#f5f0e8] text-sm font-bold mb-3" data-id="element-624">
                Lo que incluye para tu operativa:
              </p>
              <ul className="space-y-2" data-id="element-625">
                <li className="flex items-start gap-2 text-xs text-[#8a8578]" data-id="element-626">
                  <Check className="w-4 h-4 text-[#00C853] flex-shrink-0 mt-0.5" data-id="element-627" />
                  <span data-id="element-628">
                    <strong className="text-[#f5f0e8] font-medium" data-id="element-629">
                      Diagnóstico de Termostato:
                    </strong>{' '}
                    Descubre el tope de dinero que tu subconsciente te permite
                    ganar antes de sabotearte.
                  </span>
                </li>
                <li className="flex items-start gap-2 text-xs text-[#8a8578]" data-id="element-630">
                  <Check className="w-4 h-4 text-[#00C853] flex-shrink-0 mt-0.5" data-id="element-631" />
                  <span data-id="element-632">
                    <strong className="text-[#f5f0e8] font-medium" data-id="element-633">
                      Protocolo de Energía y Vibración:
                    </strong>{' '}
                    Cómo operar desde la certeza y no desde la necesidad
                    (escasez).
                  </span>
                </li>
                <li className="flex items-start gap-2 text-xs text-[#8a8578]" data-id="element-634">
                  <Check className="w-4 h-4 text-[#00C853] flex-shrink-0 mt-0.5" data-id="element-635" />
                  <span data-id="element-636">
                    <strong className="text-[#f5f0e8] font-medium" data-id="element-637">
                      Scripts de Intervención:
                    </strong>{' '}
                    Qué decirte exactamente tras una pérdida para no entrar en
                    "operativa de venganza".
                  </span>
                </li>
                <li className="flex items-start gap-2 text-xs text-[#8a8578]" data-id="element-638">
                  <Check className="w-4 h-4 text-[#00C853] flex-shrink-0 mt-0.5" data-id="element-639" />
                  <span data-id="element-640">
                    <strong className="text-[#f5f0e8] font-medium" data-id="element-641">
                      Fichas de Identidad:
                    </strong>{' '}
                    Alinea tu SER con el TENER antes de que el mercado te ponga
                    a prueba.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Tip */}
        <div className="mt-6 pt-4 border-t border-[#333]" data-id="element-642">
          <p className="text-xs text-center italic text-[#00C853]/80" data-id="element-643">
            "Un solo trade impulsivo por 'necesidad' te cuesta 10 veces más que
            estos $9. Protégete hoy."
          </p>
        </div>
      </div>
    </div>;
}